import { render, staticRenderFns } from "./Cria_Usuario.vue?vue&type=template&id=5c875e78&"
import script from "./Cria_Usuario.vue?vue&type=script&lang=js&"
export * from "./Cria_Usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports